/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base colors for the Material Dashboard 2 PRO React.
 * You can add new color using this file.
 * You can customized the colors for the entire Material Dashboard 2 PRO React using thie file.
 */

const colors = {
  background: {
    default: "#f6f1ea",
    paper: "#fffdfa",
    card: "#ffffff",
    muted: "#ece4d8",
    elevated: "#fff7ef",
    accent: "#f3edff",
    sidenav: "#0b0b10",
  },

  text: {
    main: "#6f6b79",
    focus: "#17161f",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#17161f",
    focus: "#0f0e15",
  },

  secondary: {
    main: "#948fa1",
    focus: "#7a7487",
  },

  info: {
    light: "#f0e7ff",
    main: "#7f56d9",
    focus: "#6941c6",
  },

  success: {
    main: "#2ea972",
    focus: "#22855a",
  },

  warning: {
    main: "#de9b48",
    focus: "#c9832f",
  },

  error: {
    main: "#ef6a5b",
    focus: "#dc5242",
  },

  light: {
    main: "#fffaf2",
    focus: "#f3ecdf",
  },

  dark: {
    main: "#1d1b25",
    focus: "#121018",
  },

  grey: {
    100: "#fffdf9",
    200: "#f4eee4",
    300: "#e3dccf",
    400: "#cbc3b5",
    500: "#aaa3b0",
    600: "#8b8493",
    700: "#6f6878",
    800: "#4f4a57",
    900: "#2f2b36",
  },

  gradients: {
    primary: {
      main: "#2a2634",
      state: "#111018",
    },

    secondary: {
      main: "#a79fb4",
      state: "#7b7388",
    },

    info: {
      light: "#cbb8ff",
      main: "#7f56d9",
      state: "#6941c6",
    },

    success: {
      main: "#4bc887",
      state: "#2ea972",
    },

    warning: {
      main: "#ebb06b",
      state: "#de9b48",
    },

    error: {
      main: "#f48a78",
      state: "#ef6a5b",
    },

    light: {
      main: "#fffaf2",
      state: "#f1e8db",
    },

    dark: {
      main: "#26222f",
      state: "#0b0b10",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#dbe4f1",
      text: "#2c3446",
    },

    secondary: {
      background: "#ecf1f6",
      text: "#64748b",
    },

    info: {
      background: "#d9f0fb",
      text: "#2d81b2",
    },

    success: {
      background: "#d8f3e7",
      text: "#1c8a5c",
    },

    warning: {
      background: "#fde7d8",
      text: "#cb6f2a",
    },

    error: {
      background: "#fde1e4",
      text: "#c84a54",
    },

    light: {
      background: "#ffffff",
      text: "#94a3b8",
    },

    dark: {
      background: "#c9d4e2",
      text: "#1e293b",
    },
  },

  coloredShadows: {
    primary: "#2c3446",
    secondary: "#64748b",
    info: "#56addf",
    success: "#22a06b",
    warning: "#f39a56",
    error: "#e05b65",
    light: "#c3cedb",
    dark: "#334155",
  },

  inputBorderColor: "#dbe4ee",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
